import { IIsiDtoAutoRefreshSettings } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject";
import { getMenuItemFromKey } from "../../menu.ts";
import { IsiShortcut, IsiScreenType } from "../../Isilog.enums";
import { iws_isInConsultState } from "../../basic";
import { iws_GetPageName } from "../../tools.ts";

export class IsiAutoRefresh {

    _autoRefresh: IIsiDtoAutoRefreshSettings
    _milliCoef: number;
    _type: IsiScreenType;
    _timeout: number;
    _refreshButton: boolean;
    _timer: number;
    _pageDuration: number;
    _pulseConst: number;
    _menu: string;

    constructor(autoRefresh: IIsiDtoAutoRefreshSettings, menu: string) {

        this._autoRefresh = autoRefresh;
        // 1 minute
        this._milliCoef = 60000;
        this._type = IsiScreenType.NonDefinit;
        this._timeout = 0;
        this._refreshButton = false;
        this._timer = null;
        // Definit un compteur pour les pulsations
        this._pageDuration = 0;
        // représente le temps avant déconnection
        this._pulseConst = -1;

        this._menu = menu;

        this.IsiRegister(this._autoRefresh.type as IsiScreenType, this._autoRefresh.period)
    }

    /**
    * Enregistre un ecran pour le rafraichissement auto.
    * S'il y en a plusieurs, c'est le dernier qui gagne.
    * 
    */
    IsiRegister(type: IsiScreenType, timeout: number) {
        this._type = type;
        this._timeout = timeout;
        // Appel l'initiatisation du controle.
        this._init();
    }
    /**
    * Initialisation de l'objet de gestion de l'auto-refresh.
    * 
    */
    _init() {
        if (this._timeout) {
            // convertion en millisecondes
            this._timeout = this._timeout * this._milliCoef;
        }
        else {
            // 5 minutes en millisecondes
            this._timeout = 5 * this._milliCoef;
        }
        // recupere le bouton de refresh
        this._refreshButton = this._getRefreshButton();
        // s'il existe on cree le timer
        if (this._isToCreateTimeOrRefresh()) {
            this._createNewTimer();
        }
    }
    /**
    * Teste si on peut creer le timer ou lancer le refresh
    * 
    */
    _isToCreateTimeOrRefresh() {
        return this._refreshButton && this._stateOk();
    }
    /**
    * Recupere le bouton de refresh, selon l'ecran affiche
    * 
    */
    _getRefreshButton() {
        var obj = null;
        var buttonExists = false;
        switch (this._type) {
            case IsiScreenType.VT:
            case IsiScreenType.VA:
                obj = uiCore.menuManager.existMenu(this._menu);
                break;
            case IsiScreenType.Formulaire:
                // le portail ne charge pas les menus, on utilise ici le fonctionnement d'avant
                if (iws_GetPageName() === "GLOB000") {
                    obj = jQuery("[key='" + FORM_REFRESH + "']");
                }
                else {
                    obj = getMenuItemFromKey(MNU_MASTER, IsiShortcut.CstMenuNavigation, FORM_REFRESH);
                }
                break;
        }
        if (obj) {
            buttonExists = true;
        }

        return buttonExists;
    }
    /**
    * Lance le refresh, selon l'ecran affiche.
    *
    */
    _launchRefresh(): boolean {
        const date = new Date();
        let obj = document.getElementById("ihdAutoRefresh");
        let recreateTimer = false;

        if (obj) {
            obj.innerHTML = `AUTO:${date.toISOString()}`;
            obj = null;
        }
        // TABO  05/11/2014 PB0013388: prise en compte de rafraichissement  des zones non actif ajoute de Else if
        switch (this._type) {
            case IsiScreenType.VT:
            case IsiScreenType.VA:
                // THEC - 09/03/2023 - PB0019615 - On rafraichit seulement la grille
                const currentComp = uiCore.associatedViewManager.currentComponent;
                if (currentComp) {
                    currentComp.refresh();
                }
                recreateTimer = true;
                break;
            case IsiScreenType.Formulaire:
                //JSOU - 25/09/2017 - DYSF80518 - On simule maintenant le clic avec la methode 
                uiCore.menuManager.openMenu(MNU_MASTER, IsiShortcut.CstMenuNavigation, FORM_REFRESH);
                break;
        }
        return recreateTimer;
    }
    /**
    * Verifie qu'il n'y a pas de popin d'affichee.
    * 
    */
    _isPopinShow() {
        let popinShow = false;
        if (uiCore.getCurrentPopin()) {
            popinShow = true;
        }
        return popinShow;
    }
    /**
    * Verifie que l'etat du curseur est compatible avec le refresh : c'est a dire seulement CONSULTATION.
    * Sauf la VT qui est toujours OK.
    * 
    */
    _stateOk() {
        if (this._type == IsiScreenType.VT) {
            return true;
        } else {
            return iws_isInConsultState();
        }
    }
    /**
    * Creation du timer de rafraichissement.
    * 
    */
    _createNewTimer() {
        // suppression d'un eventuel timer precedent
        this._clearTimer();

        this._timer = window.setTimeout(
            function (self) {
                return function () {
                    self._timerHandler();
                };
            }(this), this._timeout);
    }
    /**
    * Supprime le timer de rafraichissement en cours
    * */
    _clearTimer() {
        if (this._timer) {
            window.clearTimeout(this._timer);
            delete this._timer;
        }
    }
    /**
    * Gestion a echeance du timer.
    * 
    */
    _timerHandler() {
        let recreateTimer = false;
        //DYSF51568 LLGU permet déviter une déconnexion au meme moment qu'un autorefresh
        //on compare le temps avant déconnexion en fonction de la durée d'innactivité sur la page plus 5seconde
        //évitant ainsi les conflits
        if (this._pulseConst === -1 || this._pulseConst === 0 || this._pulseConst > (this._pageDuration + 0.1)) {
            try {
                if (this._isToCreateTimeOrRefresh()) {
                    if (!this._isPopinShow()) {
                        recreateTimer = this._launchRefresh();
                    } else {
                        recreateTimer = true;
                    }
                }
            }
            catch (ex) {
                recreateTimer = true;
            }
        }
        if (recreateTimer) {
            this._createNewTimer();
        }
    }
}
